module.exports = __webpack_public_path__ + "static/media/PLT-Logo.f697ca78.png";